export default __webpack_public_path__ + "static/media/no-result-ai-columns.3ff09b5f.svg";